import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]
  
  add(event) {
    event.preventDefault()
    
    const tagName = this.inputTarget.value.trim()
    if (tagName === '') return
    
    // Disable input and button during submission
    this.inputTarget.disabled = true
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
    }
    
    // Create form data for Turbo
    const formData = new FormData()
    formData.append('tag[name]', tagName)
    
    fetch('/tags', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: formData
    })
    .then(response => {
      if (response.ok) {
        return response.text()
      } else {
        throw new Error('Failed to create tag')
      }
    })
    .then(turboStreamResponse => {
      // Clear input
      this.inputTarget.value = ''
      
      // Re-enable input and button
      this.inputTarget.disabled = false
      if (this.hasButtonTarget) {
        this.buttonTarget.disabled = false
      }
      
      // Let Turbo handle the stream response
      Turbo.renderStreamMessage(turboStreamResponse)
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Failed to create tag')
      
      // Re-enable input and button
      this.inputTarget.disabled = false
      if (this.hasButtonTarget) {
        this.buttonTarget.disabled = false
      }
    })
  }
}